import AssetDepreciationProfiles from './AssetDepreciationProfiles'
export default AssetDepreciationProfiles